import { render, staticRenderFns } from "./ScrollControl.vue?vue&type=template&id=79db747c&scoped=true&"
import script from "./ScrollControl.vue?vue&type=script&lang=js&"
export * from "./ScrollControl.vue?vue&type=script&lang=js&"
import style0 from "./ScrollControl.vue?vue&type=style&index=0&id=79db747c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79db747c",
  null
  
)

export default component.exports